import React from 'react';
import FacilityActions from '../actions/FacilityActions';
import FacilityStore from '../stores/FacilityStore';
import ViewerActions from '../actions/ViewerActions';
import KnowledgeLibrary from './KnowledgeLibrary';
import MediaGallery from './mediaGallery/MediaGallery';
import FacilityMapView from './FacilityMapView';
import AssetTagsBar from './AssetTagsBar';
import FacilityExplorerSidebar from './FacilityExplorerSidebar';
interface FacilityExplorerAppProps {
    // Empty for now, can be extended if needed
}

interface FacilityExplorerAppState {
    selectedFacility?: IFacilityDetail;
    isKnowledgeLibraryOpen?: boolean;
    isMediaGalleryOpen?: boolean;
    assetSearchbarOpen?: boolean;
}

function getFacilityExplorerAppState(): FacilityExplorerAppState {
    return {
        selectedFacility: FacilityStore.getSelectedFacility(),
        isKnowledgeLibraryOpen: FacilityStore.getKnowledgeLibraryOpen(),
        isMediaGalleryOpen: FacilityStore.getMediaGalleryOpen(),
        assetSearchbarOpen: FacilityStore.getAssetSearchbarOpen(),
    } as FacilityExplorerAppState
}

class FacilityExplorerApp extends React.Component<FacilityExplorerAppProps, FacilityExplorerAppState> {
    
    constructor(props: FacilityExplorerAppProps, context: any) {
        super(props, context);
        this.state = getFacilityExplorerAppState();
    }

    private _onChange = () => {
        this.setState(getFacilityExplorerAppState());
    }

    componentDidMount() {
        FacilityStore.addChangeListener(this._onChange);
    }

    componentWillUnmount() {
        FacilityStore.removeChangeListener(this._onChange);
    }

    private _openView360 = (view: IView360Detail) => {
        ViewerActions.showPanoViewerImage(view);
    }

    public render() {
        return (
            <>
                <FacilityExplorerSidebar />
                {this.state.selectedFacility &&
                    <AssetTagsBar mode="facility" />
                }
                <div className="facility-app-container view-collapsed">
                    {this.state.isMediaGalleryOpen ? (
                        <MediaGallery openViewHandler={this._openView360} />
                    ) : this.state.isKnowledgeLibraryOpen ? (
                        <KnowledgeLibrary />
                    ) : (
                        <FacilityMapView openViewHandler={this._openView360} />
                    )}
                </div>
            </>
        );
    }
}

export default FacilityExplorerApp;
